import { Divider, Grid, Typography } from '@mui/material';
import React from 'react';
import { LinkProps, Link as RouterLink } from 'react-router-dom';

import type { ClientUserAccountListProps } from '.';

const Link = (RouterLink as unknown) as React.ComponentClass<LinkProps>;

export default function ClientUserAccountList(props: ClientUserAccountListProps) {
    const {
        classes,
        mappedUser
    } = props;

    if (!mappedUser.user || !mappedUser.firm) return <div />;

    return (
        <Grid
            className={classes.root}
            component={Link}
            container
            direction='column'
            id={`clientUserAccountList_User-${mappedUser?.user?.UserId}`}
            spacing={0}
            to={`/admin/firms/${mappedUser?.user?.FirmId}/users/${mappedUser?.user?.UserId}`}
        >
            <Typography
                className={`${classes.primaryText} ${classes.userName}`}
                variant='body1'
            >{mappedUser.user.FirstName} {mappedUser.user.LastName}
            </Typography>
            <Typography
                className={classes.secondaryText}
                variant='body2'
            >{mappedUser.user.Email}
            </Typography>
            <Typography
                className={`${classes.primaryText} ${classes.firmName}`}
                variant='body1'
            >{mappedUser.firm.Name}
            </Typography>
            <Divider
                className={classes.divider}
                variant='fullWidth'
            />
            {mappedUser.accounts?.length > 0 ?
                <>
                    <Typography
                        className={`${classes.secondaryText} ${classes.walletsLabel}`}
                        variant='body2'
                    >Linked Wallets:
                    </Typography>
                    {mappedUser.accounts?.map(account => (
                        <div
                            className={classes.walletNameContainer}
                            id={`clientUserAccountList_User-${mappedUser?.user?.UserId}_Account-${account?.account?.AccountId}`}
                            key={account?.userAccount?.UserAccountId}
                        >
                            <Typography
                                className={`${classes.secondaryText} ${classes.walletNameText}`}
                                variant='body2'
                            >{account?.account?.AccountName}
                            </Typography>
                        </div>
                    ))}
                </>
                : (
                    <Typography
                        className={classes.walletsLabel}
                        variant='body2'
                    >
                        No Linked Wallets
                    </Typography>
                )}
        </Grid>
    );
}